import React from "react";

export default function RadioButtons({
  radioName,
  checkedValue,
  onHandleChange,
  options,
  disableFields = {},
}) {
  return (
    <div className="flex gap-6">
      {options.map((option, index) => {
        return (
          <div className="inline-flex items-center" key={index}>
            <label
              className="relative flex items-center cursor-pointer"
              htmlFor={option.label}
            >
              <input
                name={radioName}
                type="radio"
                className={`peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-[#124699] transition-all ${
                  disableFields[option.value]
                    ? "bg-gray-200 border-gray-200"
                    : "bg-white"
                }`}
                id={option.label}
                value={option?.value}
                checked={checkedValue === option?.value}
                onChange={onHandleChange}
                disabled={disableFields[option.value]}
              />
              <span className="absolute bg-[#124699] w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
            </label>
            <label
              className="ml-2 text-slate-700 cursor-pointer text-sm capitalize font-semibold"
              htmlFor={option.label}
            >
              {option.value}
            </label>
          </div>
        );
      })}
    </div>
  );
}
